import { CUSTOMER_APIS, EMR_APIS } from "@/api_framework/api_config";

import { IEMRUpdateResponse } from "@/api_framework/api_modals/EMRs";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";

import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";

import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});
export const useVaccinationDeleteAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (vaccination_id: string, otherReason: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response: any = await axios
          .patch(
            `${CUSTOMER_APIS?.PET_WISE_VACCINATION?.baseURL}?vaccination_id=${vaccination_id}`,
            { delete_reason: otherReason },
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<IEMRUpdateResponse>) => {
            if (res.data.status === true && res.data) {
              toast.success("Vaccination Deleted Successfully");
              return { status: true };
            } else {
              return { status: false };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);

            captureError(e);
            return { status: false };
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return execute;
};
